import { render } from "./Article.vue?vue&type=template&id=70d12c7e&ts=true&lang=pug"
import script from "./Article.vue?vue&type=script&lang=ts&setup=true"
export * from "./Article.vue?vue&type=script&lang=ts&setup=true"

import "./Article.vue?vue&type=style&index=0&id=70d12c7e&lang=scss"

import exportComponent from "/home/kryltcov/WebstormProjects/sa_website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__